<template>
    <div>
        <!-- 对话框 -->
        <el-dialog title="发放畅行卡" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px"
            destroy-on-close>
            <!-- 基本信息表单 -->
            <div class="form-box">
                <template>
                    <el-form ref="form" label-width="130px" style="height: 500px">


                            <el-form-item>
                                <div>
                                    <el-button type="primary" style="margin-bottom: 10px"
                                        @click="download1">下载模板</el-button>
                                    <div style="color:red;font-size: 12px;">注：下载的csv表格文件，第一列为手机号</div>

                                    <el-upload style="width: 350px; height: 200px; line-height: 20px"
                                        class="upload-demo" drag accept=".csv" :action="text_upload_url"
                                        :before-upload="beforeAvatarUpload" :headers="text_headers"
                                        :data="submit_data_send" :on-success="getExcelData">
                                        <div class="el-upload__text upload">将文件拖到此处，或<em>点击上传</em></div>
                                    </el-upload>
                                </div>
                            </el-form-item>

                    </el-form>

                </template>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    var _this;
    import { config } from '@/utils/config'; // 配置
    //终端安装插件 npm install --save csv-exportor
    // import {exportCsv} from '@/utils/utils.js';
    import CsvExportor from "csv-exportor"; //引入安装的插件

    export default {
        props: {
            isShow: Boolean,
            data: ''
        },
        watch: {
            isShow(newData, oldData) {
                _this.show = true;

                _this.submit_data_send.card_code = _this.data;
            }
        },
        data() {
            return {

                downFileData: [{ phone: '13454565434' }],//csv 文件数据

                text_upload_url: config.axios_baseURL + '/card/sendCardBatch',
                // 上传文件的请求头
                text_headers: {
                    'city-tag': '',
                    token: '',
                    'hash-key': '',
                    platform: 'pc',
                    'app-version': 'admin',
                    port: 'admin',
                    'service-tag':''
                },


                excelData: [],


                card_code: '',

                show: false,


                // 表单数据

                submit_data_send: {

                },

            };
        },
        created() {
            _this = this;
        },

        methods: {
            // 下载模板方法
            download1() {
                let tableData = _this.downFileData;

                let header = ['13345678765'];
                CsvExportor.downloadCsv(tableData, { header }, "批量发放畅行卡模板.csv");
            },




            beforeAvatarUpload(file) {

                // 添加请求头
                _this.text_headers['city-tag'] = localStorage.getItem('city_tag');
                _this.text_headers.token = localStorage.getItem('access_token');
                _this.text_headers['hash-key'] = _this.$hash_key();
                _this.text_headers['service-tag'] =localStorage.getItem('service_tag');



                

            },

            getExcelData(response) {
                if (response.data.length == 0) {
                    this.$message.success('批量操作全部成功！');
                    _this.$emit('onSubmit');
                    _this.closeDialog();
                    return;
                }
                this.$message.error('符合条件数据已导入，异常数据见excel表格！');

                if (this.$route.path == '/Card') {
                    // 导出excel的空数组中添加数据
                    for (let i = 0; i < response.data.length; i++) {
                        // 向excelData数组里添加
                        _this.excelData.push({
                            phone: response.data[i][0],

                            why: response.data[i][1]
                        });
                    }

                    // 将数据导出excel
                    _this.exportData();
                    console.log(_this.excelData, '_this.excelData');

                    // 清空数据
                    _this.excelData = [];
                }
            },
            // 导出excel方法
            exportData() {
                const { export_json_to_excel } = require('@/vendor/Export2Excel');
                const tHeader = ['电话号',  '失败原因'];
                const filterVal = ['phone',  'why'];
                const list = this.excelData;
                const data = this.formatJson(filterVal, list);
                export_json_to_excel(tHeader, data, '导入失败数据');
            },

            formatJson(filterVal, jsonData) {
                return jsonData.map((v) => filterVal.map((j) => v[j]));
            },
            // 关闭方法
            closeDialog() {
                _this.show = false;

                _this.submit_data_send = {
                    // card_code: '',
                    // operation: 'priority_coupon',
                    // mode: 'add'
                };
            },


        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }
</style>